import { DEFAULT_COLOR } from '../designPageTypes';
import { normalizeHex } from '../designPageUtils';

/* eslint-disable no-unused-vars -- callback params are type-only */
type DesignColorInputProps = {
  value: string;
  label: string;
  onChange: (color: string) => void;
};
/* eslint-enable no-unused-vars */

const DesignColorInput = ({ value, label, onChange }: DesignColorInputProps) => (
  <div className="design-page__field design-page__field--color">
    <div className="design-page__color-inputs">
      <input
        type="color"
        className="design-page__color-swatch"
        value={normalizeHex(value) || DEFAULT_COLOR}
        onChange={(e) => onChange(e.target.value)}
        aria-label={`${label} color`}
      />
      <input
        type="text"
        className="design-page__color-hex"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        spellCheck={false}
        maxLength={7}
        aria-label={`${label} hex color`}
      />
    </div>
  </div>
);

export default DesignColorInput;
